// extracted by mini-css-extract-plugin
module.exports = {"container":"b_b","collections":"b_c","bottomSection":"b_d"};